import { Icon, Lock } from "@ews-admin/global-design-system";
import React from "react";

type LicenceGateProps = {
  isLicenced: boolean;
  tooltipText: string;
  onRestrictedClick: () => void;
  children: React.ReactElement;
};

export const LicenceGate: React.FC<LicenceGateProps> = ({
  isLicenced,
  tooltipText,
  onRestrictedClick,
  children,
}) => {
  if (isLicenced) {
    return children;
  }

  return (
    <div className="relative">
      <div className="pointer-events-none opacity-50">{children}</div>
      <div
        className="absolute inset-0 cursor-pointer"
        title={tooltipText}
        onClick={onRestrictedClick}
      />
      <span className="pointer-events-none absolute right-3 top-1/2 z-10 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-amber-200">
        <Icon icon={Lock} size={14} className="text-amber-600" />
      </span>
    </div>
  );
};
